;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('customFieldSearch', customFieldSearchDirective)

  CustomFieldSearchController.$inject = ['$scope', 'DatePickerService', 'FilterService']

  function CustomFieldSearchController ($scope, DatePickerService, FilterService) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        groupFind: FilterService.groupFind,
        addCriteriaHelper: addCriteriaHelper,
        selectCustomDateRange: selectCustomDateRange,
        searchCustomFieldText: searchCustomFieldText,
        usableCustomFields: _.filter(angular.copy(self.customFields), function (cf) {
          return !_.includes(['Multi', 'File'], cf.type)
        })
      })
    }
    var customRanges = [
      {
        label: '3 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
      },
      {
        label: '6 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
      },
      {
        label: '1 an',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
      },
      {
        label: '2 ans',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
      }
    ]

    $scope.$watch(function () {
      return self.customFields
    }, function () {
      self.usableCustomFields = _.filter(angular.copy(self.customFields), function (cf) {
        return !_.includes(['Multi', 'File'], cf.type)
      })
    })


    function addCriteriaHelper (value, negation) {
      if (self.selectedField.type === 'String') {
        value.label = self.selectedField.label
        self.addCriteria({key: 'customFields.' + self.selectedField.key, value: value, negation: negation})
      } else {
        self.addCriteria({key: 'customFields.' + self.selectedField.key, value: {label: self.selectedField.label, v: value}, negation: negation})
      }
    }

    function selectCustomDateRange () {
      DatePickerService.getRange(new Date(), {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        self.addCriteria({key: 'customFields.' + self.selectedField.key, value: {label: self.selectedField.label, v: dates}})
        self.selectedField = null
      })
    }

    function searchCustomFieldText (search) {
      if (!self.selectedField) return
      self.customText = self.customText || {}
      return FilterService.searchCustomFieldText(search, 'customFields.' + self.selectedField.key, self.manager).then(function (result) {
        self.customText[self.selectedField.index] = result
      })
    }
  }

  customFieldSearchDirective.$inject = []

  function customFieldSearchDirective () {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        customFields: '=',
        manager: '=',
        addCriteria: '&'
      },
      controller: CustomFieldSearchController,
      controllerAs: 'ctrl',
      templateUrl: '/app/common/directives/custom-field-search/custom-field-search.html'
    }
  }
})(window.angular, window._, window.moment)
